import { render, staticRenderFns } from "./TLabel.vue?vue&type=template&id=40e235d2&"
import script from "./TLabel.vue?vue&type=script&lang=js&"
export * from "./TLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e235d2')) {
      api.createRecord('40e235d2', component.options)
    } else {
      api.reload('40e235d2', component.options)
    }
    module.hot.accept("./TLabel.vue?vue&type=template&id=40e235d2&", function () {
      api.rerender('40e235d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/TLabel.vue"
export default component.exports